<div class="flex gap-1 items-center">
  <span class="text-proffeo-muted text-sm">
    {{ 'task-details-modal-tracked-time' | translate }} :
    {{ $safeNavigationMigration(activity().data?.duration) | intlDuration }}
  </span>
</div>
